import { $Color } from '@suntex.core/color';
import { StrictNodeModel, icons } from '@suntex.fim/hub';

export interface ModuleIconProps {
  node: StrictNodeModel;
  size?: 'sm' | 'lg';
}

export function ModuleIcon({ node, size }: ModuleIconProps) {
  const emSize = size === 'lg' ? '4em' : '2em';
  const dimensions = { width: emSize, height: emSize };
  const icon = node.icon.image ? (
    <img alt="" src={icons[node.icon.image]} style={dimensions} />
  ) : (
    <div
      style={{
        ...dimensions,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1em',
        fontWeight: 'bold',
      }}
    >
      {node.icon.text.length === 1 ? node.icon.text : '•'}
    </div>
  );

  return (
    <div
      aria-hidden="true"
      style={{
        color: 'inherit',
        backgroundColor: $Color.toHexString($Color.from(node.color)),
        borderRadius: '50%',
        padding: '.25em',
        flexShrink: 0,
      }}
    >
      {icon}
    </div>
  );
}
